<template>
  <div class="failed-payment">
    <h1 class="failed-payment__title">
      Сожалеем, платеж не прошел!
    </h1>
    <p class="failed-payment__text">
      Пожалуйста, проверьте данные вашей карты. Возможно, карта просрочена или
      недостаточно средств. Попробуйте использовать другую карту для оплаты.
    </p>
    <el-button type="primary" @click="goToPayment">
      Перейти к оплате
    </el-button>
  </div>
</template>

<script>
export default {
  name: "FailedPayment",
  methods: {
    goToPayment() {
      this.$router.push({ name: "Tariffs" });
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/styles/helpers/variables";
@import "src/assets/styles/helpers/mixin";

.failed-payment {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15%;

  &__title {
    font-weight: 300;
    font-size: 5.2rem;
    color: $text;
    text-align: center;
    margin-bottom: 20px;

    @media (max-width: $screen-xs-min) {
      font-size: 3.6rem;
    }
  }

  &__text {
    text-align: center;
    margin: 0 auto 60px;
    width: 60%;
  }
}
</style>
